import { Routes } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { HomeComponent } from "../components/home/home.component";
import { UnimplementedComponent } from "../components/unimplemented/unimplemented.component";
import { RegisterComponent } from "../components/register/register.component";
import { BookACourtComponent } from "../components/book-a-court/book-a-court.component";
import { InvitePlayersComponent } from "../components/invite-players/invite-players.component";
import { ConfirmMatchComponent } from "../components/confirm-match/confirm-match.component";
import { ConfirmationComponent } from "../components/confirmation/confirmation.component";
import { SearchPlayersComponent } from "../components/search-players/search-players.component";
import { NotificationComponent } from "../components/notification/notification.component";
import { MatchHistoryComponent } from "../components/match-history/match-history.component";
import { AvailablePlayersComponent } from "../components/available-players/available-players.component";
import { ProfileComponent } from "../components/profile/profile.component";
import { EditProfileComponent } from "../components/edit-profile/edit-profile.component";
import { YourMatchComponent } from "../components/your-match/your-match.component";
import { EmployeeInterfaceComponent } from "../components/employee-interface/employee-interface.component";
import { CourtBookingsComponent } from "../components/court-bookings/court-bookings.component";
import { ManualBookComponent } from "../components/manual-book/manual-book.component";
import { FixedBookingComponent } from "../components/fixed-booking/fixed-booking.component";
import { MatchConfirmationsComponent } from "../components/match-confirmations/match-confirmations.component";
import { SystemAlertsComponent } from "../components/system-alerts/system-alerts.component";
import { RbRankComponent } from "../components/rb-rank/rb-rank.component";
import { FriendshipsComponent } from "../components/friendships/friendships.component";
import { ClubMembershipComponent } from "../components/club-membership/club-membership.component";
import { MyClubComponent } from "../components/my-club/my-club.component";
import { PromotionsComponent } from "../components/promotions/promotions.component";
import { NewRegistrationsComponent } from "../components/new-registrations/new-registrations.component";
import { ApproveMatchesComponent } from "../components/approve-matches/approve-matches.component";
import { LoginComponent } from "../components/login/login.component";
import { ForgotPasswordComponent } from "../components/forgot-password/forgot-password.component";
import { PasswordResetComponent } from "../components/password-reset/password-reset.component";
import { AuthGuard } from "./auth-guard";
import { AnalyticsComponent } from "../components/analytics/analytics.component";
import { LogoutComponent } from "../components/logout/logout.component";
import { PrivacyComponent } from "../components/privacy/privacy.component";
import { ClubsComponent } from "../components/clubs/clubs.component";
import { LandingComponent } from "../components/landing/landing.component";
import { LandingRedirectGuard } from "./landing-redirect.guard";
import { NativeAdminStartGuard } from "./native-admin-start.guard";
import { NotFoundComponent } from "../components/not-found/not-found.component";
import { TournamentsListComponent } from "../components/tournaments-list/tournaments-list.component";
import { TournamentDetailComponent } from "../components/tournament-detail/tournament-detail.component";
import { TournamentCreateComponent } from "../components/tournament-create/tournament-create.component";
import { TournamentManageComponent } from "../components/tournament-manage/tournament-manage.component";
import { MyTournamentsComponent } from "../components/my-tournaments/my-tournaments.component";

export const routes: Routes = [
  { path: "home", component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: "",
    canActivate: [LandingRedirectGuard],
    component: LandingComponent,
    pathMatch: "full",
  },
  { path: "landing", component: LandingComponent },
  {
    path: "clubs",
    component: ClubsComponent,
    canActivate: [NativeAdminStartGuard],
  },
  { path: "unimplemented", component: UnimplementedComponent },
  {
    path: "book-a-court/:id",
    component: BookACourtComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "invite-players/:idx",
    component: InvitePlayersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "confirm-match",
    component: ConfirmMatchComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "confirmation/:type",
    component: ConfirmationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "search-players/:idx",
    component: SearchPlayersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "notification",
    component: NotificationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "match-history",
    component: MatchHistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "available-players/:id/:idx",
    component: AvailablePlayersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "profile/:id",
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-profile",
    component: EditProfileComponent,
    canActivate: [AuthGuard],
  },
  { path: "logout", component: LogoutComponent },
  {
    path: "your-match/:id",
    component: YourMatchComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "employee-interface",
    component: EmployeeInterfaceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "analytics",
    component: AnalyticsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "court-bookings",
    component: CourtBookingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "manualBook",
    component: ManualBookComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "fixed-booking",
    component: FixedBookingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "match-confirmations",
    component: MatchConfirmationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "system-alerts",
    component: SystemAlertsComponent,
    canActivate: [AuthGuard],
  },
  { path: "rb-rank", component: RbRankComponent },
  {
    path: "friendships",
    component: FriendshipsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "club-membership",
    component: ClubMembershipComponent,
    canActivate: [AuthGuard],
  },
  { path: "my-club/:id", component: MyClubComponent, canActivate: [AuthGuard] },
  {
    path: "promotions/:idClub",
    component: PromotionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "approveMatches",
    component: ApproveMatchesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "newRegistrations",
    component: NewRegistrationsComponent,
    canActivate: [AuthGuard],
  },
  { path: "register", component: RegisterComponent },
  { path: "login", component: LoginComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "passwordreset", component: PasswordResetComponent },
  { path: "privacy", component: PrivacyComponent },
  {
    path: "tournaments",
    component: TournamentsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tournaments/my",
    component: MyTournamentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tournaments/:id",
    component: TournamentDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "admin/tournaments/new",
    component: TournamentCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "admin/tournaments/:id/manage",
    component: TournamentManageComponent,
    canActivate: [AuthGuard],
  },
  { path: "**", component: NotFoundComponent },
];
